import axios from 'axios';
import { logger } from '@fiverr-private/obs';
import { countEventService } from '../../events/countEvent';
import poll from '../poll';
import { BUSINESS_API_PREFIX } from '../constants';

export const createOrganization = async ({
    migrateUser = false,
    source = '',
}: {
    migrateUser: boolean;
    source?: string;
}) => {
    try {
        const response: any = await axios
            .post(`${BUSINESS_API_PREFIX}/organization`, { migrate_user: migrateUser })
            .then(poll);

        countEventService({ metric: 'create_organization', status: 'success', source });

        return {
            organizationId: response?.organization_id as string,
        };
    } catch (error) {
        logger.error(error as any, { message: 'Error creating organization', error, flow: 'createOrganization' });
        countEventService({ metric: 'create_organization', status: 'fail', source });
        throw error;
    }
};
